import React, { ReactNode } from "react";

import loader from "src/assets/icons/loader.gif";
import { Body } from "src/components/typography/typography";

import "./loading.scss";

interface LoadingProps {
    children?: ReactNode;
}

/*
 * Main
 */

export const Loading = (props: LoadingProps): React.ReactElement => {
    const { children } = props;
    return (
        <div className="main-page-wrap page-loader">
            <div className="center loader">
                <Body>
                    <img alt="Loader icon" src={loader} />
                    {children && <div>{children}</div>}
                </Body>
            </div>
        </div>
    );
};
